module.exports = __webpack_public_path__ + "img/katalon-studio-logo-notag.91c35f81.svg";